<template>
  <div class="set_main">
    <div class="account-tit">
      <h1 class="title">
        {{ $t('message["1397"]') }}
      </h1>
    </div>
    <a-form
      :form="form"
      :hide-required-mark="true"
      class="inquiry-detail"
      @submit="handleSubmit"
    >
      <a-form-item
        class="code_form_item"
        :label="mobileTit"
      >
        <a-input
          v-decorator="[
            'mobile',
            { rules: decorators.oldmobile,initialValue: nativeMobile }]"
          :disabled="true"
        />
      </a-form-item>
      <!-- <captcha-input
        :label="imgValidTit"
      /> -->
      <a-form-item
        :label="validTit"
        class="password-box"
      >
        <a-input
          v-decorator="decorators.checkcode"
          :placeholder="telValidPlace"
        />
        <get-code
          class="find-pwd-link ml-16"
          :mobile="nativeMobile"
          type="1"
          :is-disabled="false"
          @getRes="sendCurrentPhoneCode"
        />
      </a-form-item>
      <a-form-item
        class="code_form_item"
        :label="newMobileTit"
      >
        <a-input
          v-decorator="decorators.newmobile"
          :placeholder="newMobilePlace"
        />
      </a-form-item>
      <a-form-item
        :label="validTit"
        class="password-box"
      >
        <a-input
          v-decorator="decorators.newcheckcode"
          :placeholder="newValidPlace"
        />
        <get-code
          class="find-pwd-link ml-16"
          :newmobile="form.getFieldValue('newmobile')"
          :mobile="form.getFieldValue('mobile')"
          type="5"
          :is-disabled="false"
          @getRes="sendNewPhoneCode"
        />
      </a-form-item>
      <a-form-item>
        <div class="form_btn">
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1161"]') }}
          </a-button>
          <a-button
            type="default"
            @click="resetForm"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import getCode from '@/components/pc/GetCode'
import { mapState, mapActions } from 'vuex'
// import CaptchaInput from '@/components/pc/CaptchaInput.vue'

export default {
  components: { getCode },
  data () {
    return {
      nativeMobile: ''
    }
  },
  computed: {
    ...mapState('account/modify', ['decorators', 'accountDetail']),
    getMobile () {
      return this.decorators.mobile[1].initialValue
    },
    telValidPlace () {
      return this.$t('message["802"]')
    },
    newMobilePlace () {
      return this.$t('message["817"]')
    },
    newValidPlace () {
      return this.$t('message["818"]')
    },
    mobileTit () {
      return this.$t('message["1112"]')
    },
    newMobileTit () {
      return this.$t('message["1343"]')
    },
    imgValidTit () {
      return '图片验证码'
    },
    validTit () {
      return this.$t('message["1433"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  async mounted () {
    this.setKey()
    const chain = await this.fetchAccountInfoDatas()
    chain.onSuccess(res => {
      this.setKey()
    })
      .fetch()
  },
  methods: {
    ...mapActions('account/modify', ['fetchAccountInfoDatas', 'modifyMobile']),
    setKey (vm) {
      if (this.accountDetail && this.accountDetail.mobile) {
        // this.$set(this.mainForm, 'email', this.accountDetail.email)
        this.form.setFieldsValue({ 'mobile': this.accountDetail.mobile })
        this.nativeMobile = this.accountDetail.mobile
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          // console.log('表单值：', values)
          const chain = await this.modifyMobile()
          chain.params(values)
            .onSuccess(res => {
              this.$router.push({ name: 'AccountInfo' })
            })
            .onFail(err => {
              console.log('修改失败：', err)
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    // 跳转到个人信息
    resetForm () {
      this.$router.push({ name: 'AccountInfo' })
    },
    sendNewPhoneCode (res) {
      console.log(res)
    },
    // 获取手机验证码
    sendCurrentPhoneCode (res) {
      console.log(res)
    }
  }
}
</script>

<style scoped lang="scss">
.set_main {
 padding: 24px 40px;
 .account-tit {
   margin-bottom: 24px;
 }
  .form_btn {
  button {
    margin-right: 16px
  }
}
}
</style>
